import axios from 'axios';


export function getAppointmentDetail(id) {
    return axios.get('orders/' + id)
}

export function cancelOrder(id) {
    return axios.post('orders/' + id +'/cancel')
}